<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-user text-primary"></i> {{$t('customer.titleedit')}}
            </h2>
            <hr />
            <div>
                <form @submit.prevent>
                    <div class="row">
                        <div class="col-md-12">
                            <fg-input
                                type="text"
                                :label="$t('customer.name')"
                                placeholder="Name"
                                v-model="customer.user.name"
                            ></fg-input>
                        </div>
                        <!-- <div class="col-md-4">
              <fg-input type="text" label="Customer ID" v-model="customer.customer_id"></fg-input>
                        </div>-->
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <fg-input
                                type="email"
                                :label="$t('customer.email')"
                                placeholder="E-mail"
                                v-model="customer.user.email"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label class="typo__label">{{$t('customer.documenttype')}}</label>
                            <multiselect
                                v-model="multiselect"
                                :options="doc_types"
                                :placeholder="$t('customer.text.selectone')"
                                label="name"
                                track-by="id"
                                @input="selectDocumentType"
                            ></multiselect>
                        </div>
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('customer.documentnumber')"
                                v-model="customer.document_number"
                            ></fg-input>
                        </div>
                    </div>
                    <br />
                    <fg-address v-model="customer.addresses"></fg-address>
                    <br />
                    <fg-phone v-model="customer.phones"></fg-phone>
                    <br />
                    <div class="text-left">
                        <p-button type="primary" @click.native.prevent="update">{{$t('customer.button.save')}}</p-button>
                    </div>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
    </card>
</template>
<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect
  },
  // data() {
  //   // return {
  //   //   form: {
  //   //     user: { name: "", email: "" },
  //   //     customer_id: "",
  //   //     document_type: "",
  //   //     document_number: "",
  //   //     addresses: [],
  //   //     phones: []
  //   //   }
  //   // };
  // },
  // watch: {
  //   customer: function(newData) {
  //     this.customer.id = newData.id;
  //     this.customer.user.email = newData.user.email;
  //     this.customer.user.name = newData.user.name;
  //     this.customer.customer_id = newData.customer_id;
  //     console.log(newData.addresses);
  //     if (newData.addresses) this.customer.addresses = newData.addresses;
  //     if (newData.phones) this.customer.phones = newData.phones;
  //     this.customer.document_number = newData.document_number;
  //     this.customer.document_type = newData.document_type;
  //   }
  // },
  computed: {
    ...mapState("customers", {
      customer: "customer"
    }),
    doc_types() {
      return this.$store.getters["customers/getDocTypes"];
    },
    multiselect: {
      get() {
        return this.doc_types.filter(
          type => type.name == this.customer.document_type
        );
      },
      set(value) {}
    }
  },
  created() {
    this.$store.dispatch("customers/get", this.$route.params.id);
    this.$store.dispatch("customers/getDocTypes");
  },
  methods: {
    selectDocumentType(option) {
      this.customer.document_type = option.name;
    },
    update() {
      this.$store.commit("customers/set", this.customer);
      this.$store
        .dispatch("customers/edit", this.customer)
        .then(response => {
          this.$router.push({ name: "customers" });
          this.$notify({
            type: "success",
            horizontalAlign: "center",
            message: "User added with success!"
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style>
</style>
